import { render } from "./index.vue?vue&type=template&id=d0e6652a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d0e6652a&scoped=true&lang=less"
import "@/style/login-bg.less?vue&type=style&index=1&id=d0e6652a&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0e6652a"],['__file',"src/views/serve-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0e6652a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0e6652a', __exports__)) {
    console.log('reload')
    api.reload('d0e6652a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d0e6652a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('d0e6652a', render)
  })

}


export default __exports__